// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"132":"8c660867","433":"1a1b6789","793":"4e0e2b10","972":"38f51483"}[chunkId] + ".chunk.css";
};